export function TradeButton() {
  return (
    <a
      href="https://exchange.pancakeswap.finance/#/swap"
      target="_blank"
      className="theme-text mx-4"
      rel="noreferrer noopener"
    >
      Trade
    </a>
  );
}
